import type { FC } from "react";

export interface BackButtonProps {
  handleClick: () => void;
  text?: string;
}

const BackButton: FC<BackButtonProps> = ({ handleClick, text = "Volver" }) => {
  return (
    <button onClick={handleClick} title={text} type="button">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="28"
        width="28"
        viewBox="0 0 512 512"
      >
        <path
          fill="#1C93FF"
          d="M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM231 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-71 71L376 232c13.3 0 24 10.7 24 24s-10.7 24-24 24l-182.1 0 71 71c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L119 273c-9.4-9.4-9.4-24.6 0-33.9L231 127z"
        />
      </svg>
    </button>
  );
};

export default BackButton;
